const Menu =  [
    { header: 'Admin Quran' },
    {
        path    : '/',
        title   : 'Input Nilai Quran',    
        name    : 'tes/quran',  
        icon    : 'local_library', 
    },             
];

import Remenu from '@/util/remenu';
export default Remenu(Menu);
